<style lang="less" scoped>
.item {
  display: inline-block;
  margin-right: 8px;
}

.table-btn {
  font-size: 12px;
  height: 20px;
  line-height: 5.5px;
}

.cell-content {
  display: block;
  width: 100%;
}

.cell-clickable {
  cursor: pointer;
  display: inline-block;
}

.operate-none {
  color: #909399;
  font-size: 12px;
}
</style>

<template>
  <div class="table-container">
    <el-table :data="tableData" border stripe style="width: 100%" @selection-change="handleSelectionChange"
      :height="tableConfig.maxHeight" :header-cell-style="tableConfig.herderStyle" @sort-change="handleSortChange"
      :empty-text="tableConfig.emptyText">
      <el-table-column v-if="tableConfig.showSelection" type="selection" width="40" align="center">
      </el-table-column>
      <el-table-column v-if="tableConfig.showIndex" type="index" width="40" align="center">
      </el-table-column>
      <!-- Vue2: <template> 不能加 key，需放在真实元素上 -->
      <template v-for="(column, index) in tableColumns">
        <el-table-column :key="column.props || index" :prop="column.props" :label="column.label" :width="column.width"
          :sortable="column.sortable" :fixed="column.fixed" :align="column.align || 'center'"
          :min-width="column.minWidth" :show-overflow-tooltip="column.tooltip && !column.tooltipContent">
          <template slot-scope="scope">
            <template v-if="column.slot">
              <slot :name="column.props" :row="scope.row" :column="column" :$index="scope.$index"></slot>
            </template>
            <template v-else-if="column.tooltipContent && typeof column.tooltipContent === 'function'">
              <el-tooltip :content="column.tooltipContent(scope.row)" placement="top"
                :disabled="!column.tooltipContent(scope.row) || column.tooltipContent(scope.row) === ''">
                <div class="cell-content" :class="{ 'cell-clickable': column.cellClick }"
                  :title="column.cellClick ? '点击修改状态' : ''" @click="column.cellClick && column.cellClick(scope.row)">
                  <template v-if="column.formatter">
                    <span v-html="column.formatter(scope.row, column)"></span>
                  </template>
                  <template v-else>
                    <span>{{ scope.row[column.props] }}</span>
                  </template>
                </div>
              </el-tooltip>
            </template>
            <template v-else>
              <template v-if="column.formatter">
                <span :class="{ 'cell-clickable': column.cellClick }" :title="column.cellClick ? '点击修改状态' : ''"
                  v-html="column.formatter(scope.row, column)"
                  @click="column.cellClick && column.cellClick(scope.row)"></span>
              </template>
              <template v-else>
                <span :class="{ 'cell-clickable': column.cellClick }" :title="column.cellClick ? '点击修改状态' : ''"
                  @click="column.cellClick && column.cellClick(scope.row)">{{ scope.row[column.props] }}</span>
              </template>
            </template>
          </template>
        </el-table-column>
      </template>
      <el-table-column ref="fixedColumn" label="操作" align="center" :width="operates.width" :fixed="operates.fixed"
        v-if="operates.list && operates.list.length > 0">
        <template slot-scope="scope">
          <div class="operate-group">
            <template v-for="(btn, key) in operates.list">
              <div class="item" v-if="isBtnVisible(btn, scope.row)" :key="btn.id">
                <el-button :class="['table-btn', btn.btnClass].filter(Boolean)"
                  :type="typeof btn.type === 'function' ? btn.type(scope.row) : btn.type"
                  :disabled="typeof btn.disabled === 'function' ? btn.disabled(scope.row) : btn.disabled"
                  :plain="btn.plain !== false" @click.native.prevent="btn.method(key, scope.row)">{{ typeof
                    btn.label === 'function' ? btn.label(scope.row) : btn.label }}</el-button>
              </div>
            </template>
            <span v-if="!hasVisibleBtn(scope.row)" class="operate-none">无需操作</span>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: 'ZDTable',
  props: {
    tableColumns: {
      type: Array,
      default: [],
    },
    tableData: {
      type: Array,
      default: [],
    },
    tableConfig: {
      type: Object,
      default: {},
    },
    operates: {},
  },
  data() {
    return {}
  },
  methods: {
    init() { },
    isBtnVisible(btn, row) {
      if (typeof btn.show === 'function') return btn.show(row);
      return btn.show === true;
    },
    hasVisibleBtn(row) {
      return this.operates.list && this.operates.list.some(btn => this.isBtnVisible(btn, row));
    },
    handleSelectionChange(e) {
      this.$emit('updateSelections', e);
    },
    handleSortChange(column, prop, order) {
      this.$emit('updateSort', column);
    }
  },
  mounted() {
    this.init();
  }
}
</script>